<section class="ui basic fitted section-padding segment">
  <div class="ui container p-relative">
    <h1 class="ui header">Touch Points</h1>
    <swiper class="section-topside-nav" [config]="categoryconfig">
      <div
        class="ui category link card no shadow"
        *ngFor="let trendingScreenCategory of trendingScreenCategories"
      >
        <a
          class="image"
          href="/listings?screenCategories={{ trendingScreenCategory }}"
        >
          <img
            src="{{ categoryImageMap.get(trendingScreenCategory) }}"
            onerror="this.src='assets/images/dummy-category.jpg';"
            alt="..."
          />
        </a>
        <div class="content no border">
          <a
            class="header fw-100"
            (click)="navigateToSearchPage(trendingScreenCategory)"
            >{{ trendingScreenCategory }}</a
          >
        </div>
      </div>
    </swiper>
  </div>
</section>
